import { Toast, ToastStack } from './Toast';
import { useToasts, dismissToast } from '../lib/toastStore';

// The single toast host (Issue #194). Rendered ONCE near the app root; every
// notice source (StatusToast SSE, UpdatePrompt, paFlash, …) pushes into the
// shared store and appears here in one top-right stack.
export function GlobalToasts() {
  const toasts = useToasts();
  if (!toasts.length) return null;
  return (
    <ToastStack>
      {toasts.map((t) => (
        <Toast
          key={t.id}
          variant={t.variant}
          dismiss={t.dismiss}
          autoHideMs={t.autoHideMs}
          icon={t.icon}
          title={t.title}
          onClick={t.onClick}
          onDismiss={() => { dismissToast(t.id); t.onClose?.(); }}
        >
          {t.content}
        </Toast>
      ))}
    </ToastStack>
  );
}
